import { TaskSupplierComponent } from './task-supplier/task-supplier.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationsSupplierComponent } from './notifications-supplier/notifications-supplier.component';
import { ElectricitySupplierComponent } from './electricity-supplier/electricity-supplier.component';
import { GasSupplierComponent } from './gas-supplier/gas-supplier.component';
import { SupplierContractTaskComponent } from './task-supplier/details/supplier-contract-task/supplier-contract-task.component';
import { IdentificationDataSupplierComponent } from './identification-data/identification-data-supplier.component';
import { SupplierAuthGuard } from 'src/app/shared/guard/supplierAuth.guard';
import { SupplierInvitationsComponent } from './identification-data/details/supplier-invitations.component';
import { TerminateContractComponent } from './terminate-contract/terminate-contract.component';
import { NetworkContractGasComponent } from '../operator/gas-operator/network-contract/network-contract-gas.component';
import { NetworkContractElectricityComponent } from '../operator/electricity-operator/network-contract/network-contract-electricity.component';
import { ContractIndexComponent } from 'src/app/public/contract-index/contract-index.component';
import { ElectricityConsumptionPlaceComponent } from '../supplier/electricity-supplier/consumption-place/electricity-consumption-place.component';
import { GasConsumptionPlaceComponent } from '../supplier/gas-supplier/consumption-place/gas-consumption-place.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'date-identificare',
        component: IdentificationDataSupplierComponent,
        data: {
          breadcrumb: 'Date identificare'
        }
      },
      {
        path: 'invitatii',
        component: SupplierInvitationsComponent,
        data: {
          breadcrumb: 'Conturi'
        }
      },
      {
        path: 'task-uri',
        component: TaskSupplierComponent,
        data: {
          breadcrumb: 'Task-uri'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'task-uri/contract-furnizare',
        component: SupplierContractTaskComponent,
        data: {
          breadcrumb: 'Task-uri'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'notificari',
        component: NotificationsSupplierComponent,
        data: {
          breadcrumb: 'Notificari'
        }
      },
      {
        path: 'energie-electrica',
        component: ElectricitySupplierComponent,
        data: {
          breadcrumb: 'Energie Electrica'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'energie-electrica/inceteaza-contract',
        component: TerminateContractComponent,
        data: {
          breadcrumb: 'Energie Electrica'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'energie-electrica/index',
        component: ContractIndexComponent,
        data: {
          breadcrumb: 'Energie Electrica'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'gaze-naturale',
        component: GasSupplierComponent,
        data: {
          breadcrumb: 'Gaze Naturale'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'gaze-naturale/inceteaza-contract',
        component: TerminateContractComponent,
        data: {
          breadcrumb: 'Gaze Naturale'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'gaze-naturale/index',
        component: ContractIndexComponent,
        data: {
          breadcrumb: 'Gaze Naturale'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'gaze-naturale/detalii-contract-de-retea',
        component: NetworkContractGasComponent,
        data: {
          breadcrumb: 'Detalii contract de retea gaz'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'energie-electrica/detalii-contract-de-retea',
        component: NetworkContractElectricityComponent,
        data: {
          breadcrumb: 'Detalii contract de retea energie electrica'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'energie-electrica/detalii-loc-consum',
        component: ElectricityConsumptionPlaceComponent,
        data: {
          breadcrumb: 'Detalii loc consum energie electrica'
        },
        canActivate: [SupplierAuthGuard]
      },
      {
        path: 'gaze-naturale/detalii-loc-consum',
        component: GasConsumptionPlaceComponent,
        data: {
          breadcrumb: 'Detalii loc consum gaze naturale'
        },
        canActivate: [SupplierAuthGuard]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupplierRoutingModule { }
